<template>
  <div class="camp wow fadeInUp">
    <div class="big-title"><img src="https://static.worldaic.com.cn/2024/web/static/images/c.png" alt="">ircle 生态</div>
    <div class="content">
      <swiper ref="mySwiper" :options="swiperOptions" class="my-swiper" id="swiper">
        <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="item" @click.stop="link(item, index)">
              <img :src="item.coverPc" alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['title' + En] }}</div>
                <div class="box">
                  <p class="ellipsis2">{{ item['source'] }}</p>
                  <div class="btn"><span>{{ $t('learnMore') }}</span></div>
                </div>
              </div>
            </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-btns">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/prev.png" alt="" @click="prevTo('prev')" class="prev btn-img">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/next.png" alt="" @click="prevTo('next')" class="next btn-img">
      </div>
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'camp',
  data() {
    return {
      swiperOptions: {
        autoplay: 3000,
        autoplayDisableOnInteraction : false,
        slidesPerView: 3,
        loop: true,
      },
      list: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async link(item, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','homeClick',
          {
            'floor_var': 'Circle生态',
            'position_var': index + 1 + '',
            'flowName_var': item.title,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': '无',
          }
      );
      gio('track','homeClick',
          {
            'floor_var': 'Circle生态',
            'position_var': index + 1 + '',
            'flowName_var': item.title,
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': '无',
          }
      );
      this.publink('cjdetail', item)
    },
    prevTo(str) {
      if (str === 'prev') {
        this.$refs.mySwiper.swiper.slidePrev()
      } else {
        this.$refs.mySwiper.swiper.slideNext()
      }
    },
    getData() {
      const params = {
        "pageNum": 1,
        "pageSize": 999,
        "recommendSts": 0,
      }
      protal.queryOfficialCreativeList(params).then(res => {
        this.list = res.data || []
      })
    }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .camp {
    width: 100%;
    height: 9.4rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/camp-bg.jpg");
    background-size: cover;
    padding: 1.35rem 1.1rem 0;

    .content {
      position: relative;
      width: 15rem;
      margin: 1.18rem auto 0;

      .my-swiper {
        width: 100%;

        .item {
            display: inline-block;
            vertical-align: top;
            width: 4.92rem;
            border-radius: .16rem;
            background: #F6F7F7;
            overflow: hidden;
            white-space: normal;
            cursor: pointer;
          
            img {
              display: block;
              width: 100%;
              height: 3.28rem;
              border-radius: .16rem;
            }

            .text {
              padding: .14rem .28rem .1rem;

              .title {
                font-size: .22rem;
                font-weight: bold;
                color: #3E3A39;
                line-height: .32rem;
                height: .64rem;
              }

              p {
                font-size: .18rem;
                font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                font-weight: 400;
                color: #727171;
                line-height: .28rem;
                height: .56rem;
                margin-top: .1rem;
              }

              .btn {
                text-align: right;
                padding-top: .1rem;
                height: .2rem;

                span {
                  font-size: .18rem;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #595757;
                  line-height: 1;
                  cursor: pointer;
                }
              }

              .box {
                height: 1.04rem;
                transition: .5s;
                overflow: hidden;
              }
            }

            &:hover .text {
              .box {
                height: 1.04rem;
              }
            }
          }
      }

      .btn-img {
        position: absolute;
        top: 1.52rem;
        cursor: pointer;
        width: .5rem;
        height: auto;

        &.prev {
          left: -0.86rem;
        }

        &.next {
          right: -0.86rem;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .camp {
    width: 100%;
    height: 8.8rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/camp-bg-wap.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    padding: .84rem 0 0;

    .big-title {
      margin-left: .4rem;
    }

    .content {
      position: relative;
      width: 15.16rem;
      margin: .94rem auto 0;
      left: -3.83rem;

      .my-swiper {
        width: 100%;

        .item {
            display: inline-block;
            vertical-align: top;
            width: 4.92rem;
            border-radius: .16rem;
            background: #F6F7F7;
            overflow: hidden;
            white-space: normal;
          
            img {
              display: block;
              width: 100%;
              height: 3.28rem;
              border-radius: .16rem;
            }

            .text {
              padding: .1rem .24rem .2rem;

              .title {
                font-size: .28rem;
                font-weight: 500;
                color: #3E3A39;
                line-height: .36rem;
                height: .7rem;
                font-family: sybold;
              }

              p {
                font-size: .22rem;
                font-weight: 400;
                color: #727171;
                line-height: .3rem;
                height: .6rem;
                margin-top: .05rem;
              }

              .btn {
                text-align: right;
                padding-top: .1rem;

                span {
                  display: inline-block;
                  font-size: .2rem;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #595757;
                  line-height: 1;
                  cursor: pointer;
                }
              }

              .box {
                height: 0;
                transition: .5s;
                opacity: 0;
              }
            }
          }

        /deep/ .swiper-slide-next .text {
          .box { 
            height: 1rem;
            opacity: 1;
           }
        }
      }

      .btn-img {
        position: absolute;
        top: 1.52rem;
        cursor: pointer;
        width: .5rem;
        height: auto;

        &.prev {
          left: -0.86rem;
        }

        &.next {
          right: -0.86rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/camp.vue